// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"6eaccf1b","228":"5404d06d","433":"f7e24ab7","459":"ff84f825","606":"837c5a48","830":"6e50874d"}[chunkId] + ".chunk.js";
};